import PropTypes from 'prop-types'
import { Icons } from '@/theme/Images'
import { toast } from 'sonner'
import FailureAlertIcon from '../assets/icons/failure-alert-icon'

const ToastMessage = ({ text, description, success, dismissible = true }) => {
  return (
    <div
      className="p-4 flex flex-row rounded-lg border-[1px] border-neutral-50 md:w-[400px] w-full justify-between items-start"
      data-testid="toast"
      data-success={success}
    >
      <div className="flex flex-row items-start">
        {success ? (
          <div className="mt-[-6px] ml-[-8px]" data-testid="toast-icon-success">
            <Icons.SuccessToastIcon />
          </div>
        ) : (
          <div className="mt-[-6px] ml-[-8px]" data-testid="toast-icon-failure">
            <FailureAlertIcon />
          </div>
        )}
        <div className="flex flex-col justify-center items-start ml-3">
          <p
            className={`font-semibold text-sm text-neutral-900 mb-1 font-sans`}
            data-testid="toast-text"
          >
            {text}
          </p>
          <p className="font-normal text-sm text-neutral-700 font-sans" data-testid="toast-description">
            {description}
          </p>

          {!success && dismissible && (
            <div className="flex flex-row justify-start mt-2">
              <button
                id="dismiss-button"
                aria-label="Dismiss announcement"
                data-testid="toast-dismiss"
                className="font-semibold text-sm text-left font-sans mr-1 py-1 rounded-md text-neutral-700"
                onClick={() => toast.dismiss()}
              >
                Dismiss
              </button>
              <a
                id="contact-support-button"
                aria-label="Contact support"
                data-testid="toast-contact-support"
                className="font-sans font-inter font-semibold text-sm leading-5 text-left py-1 px-2 rounded-md text-[--brand-500]"
                href="mailto:help@fasten.cc"
              >
                Contact Support
              </a>
            </div>
          )}
        </div>
      </div>
      <button
        id="toast-close-button"
        aria-label="Close"
        className="h-10 w-5 mt-[-10px] flex-shrink-0"
        onClick={() => toast.dismiss()}
      >
        <img src={Icons.closeIcon} className="cursor-pointer" alt="Close" />
      </button>
    </div>
  )
}

ToastMessage.propTypes = {
  text: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  success: PropTypes.bool.isRequired,
  dismissible: PropTypes.bool,
}

export { ToastMessage }
